import { useEffect, useState } from "react";
import { CalBookingProps } from "../RuntimeCalBooking";
import { UrlAction } from "../types";

interface UseBookerPropsProps extends CalBookingProps {
    setRescheduleUid: (uid: string) => void;
}

interface ExpectedUrlParams {
    slug: string;
    action: UrlAction;
    teamId: number;
    bookingUid: string;
    username: string;
}
export const useBookerProps = (props: UseBookerPropsProps) => {
    const [{
        slug: urlSlug,
        action: urlAction,
        teamId: urlTeamId,
        bookingUid,
        username: urlUsername,
        isUrlAction
    }] = useState(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlParams.entries()) as unknown as ExpectedUrlParams; 
        return {
            ...params,
            isUrlAction: [UrlAction.RESCHEDULE, UrlAction.CANCEL].includes(params.action as UrlAction)
        }
    });

    useEffect(() => {
        if (urlAction === UrlAction.RESCHEDULE && bookingUid) {
            props.setRescheduleUid(bookingUid);
        }
    }, []);

    if (isUrlAction) {
        return {
            eventSlug: urlSlug || props.eventSlug,
            teamId: urlTeamId || props.teamId,
            userName: urlUsername || props.userName,
        }
    }

    return props;
}   